<dac-navbar [doubleNav]="false"></dac-navbar>
<div class="container-fluid mb-3">
    <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-4">
            <div class="card card-cascade wider mt-4">
                <div class="view gradient-card-header primary-gradient">
                    <h2 class="h2-responsive"><i class="fa fa-lock"></i> Client Login</h2>
                </div>
                <app-login class="card-body text-center"></app-login>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/theme/login-page/login-page.component.html